<template>
  <div>
    <div class="password-container">
      <div class="input-container">
        <vs-input
          size="large"
          :class="computedClass"
          :placeholder="placeholder"
          :label="label"
          :type="showPassword ? 'text' : 'password'"
          :aria-label="ariaLabel"
          :value="value"
          :label-placeholder="labelPlaceholder"
          @input="updateValue"
        />
      </div>

      <div class="button-container">
        <vs-button
          class="button"
          @click="togglePasswordVisibility"
          type="icon"
          :title="showPassword ? 'Ocultar clave' : 'Ver clave'"
        >
          <i class="material-icons">
            {{ showPassword ? 'visibility_off' : 'visibility' }}
          </i>
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputPassword',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
    },
    ariaLabel: {
      type: String,
    },
    labelPlaceholder: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    customClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showPassword: false,
    }
  },
  computed: {
    computedClass() {
      return this.customClass ? `w-100 ${this.customClass}` : 'w-100'
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    updateValue(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style>
.password-container {
  position: relative;
  display: flex;
}

.password-container .input-container {
  flex: 1 1;
}

.password-container .button-container {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 100%;
  aspect-ratio: 1;
}

.password-container .button {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background-color: transparent;
  overflow: hidden;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.password-container .button:active {
  background-color: rgba(0, 0, 0, 0.1);
}

.password-container .button::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  transform: scale(0);
  opacity: 0;
  transition: transform 0.4s ease, opacity 0.6s ease;
  pointer-events: none;
}

.password-container .button-container::before {
  content: '';
  position: absolute;
  left: 0;
  width: 1px;
  background-color: rgba(0, 0, 0, 0.12);
  height: 18px;
  bottom: 50%;
  transform: translateY(50%);
  z-index: 9;
}

.password-container .button:active::after {
  transform: scale(2);
  opacity: 1;
  transition: transform 0.2s ease, opacity 0.4s ease;
}

.password-container .button .material-icons {
  font-size: 1.4em;
  line-height: 1em;
  display: block;
  color: rgba(0, 0, 0, 0.4);
}
</style>
